import React, { useReducer } from "react"; // eslint-disable-line no-unused-vars
import * as consts from "../consts";
import { State } from "./state";

const initialState = {
  alerts: [],
  busy: false,
  profile: null,
  cart: localStorage.getItem(consts.STORAGE_CART)
    ? JSON.parse(localStorage.getItem(consts.STORAGE_CART))
    : [],
  supportPercent: sessionStorage.getItem(consts.STORAGE_SUPPORT_PERCENTAGE)
    ? parseFloat(sessionStorage.getItem(consts.STORAGE_SUPPORT_PERCENTAGE))
    : consts.DEFAULT_SUPPORT_PERCENTAGE,
  supportTotal: sessionStorage.getItem(consts.STORAGE_SUPPORT_TOTAL)
    ? parseFloat(sessionStorage.getItem(consts.STORAGE_SUPPORT_TOTAL))
    : consts.DEFAULT_SUPPORT_TOTAL,
  optIn: sessionStorage.getItem(consts.STORAGE_OPT_IN)
    ? JSON.parse(sessionStorage.getItem(consts.STORAGE_OPT_IN))
    : false,
  businessUse: sessionStorage.getItem(consts.STORAGE_BUSINESS_USE)
    ? JSON.parse(sessionStorage.getItem(consts.STORAGE_BUSINESS_USE))
    : false,
  billing: sessionStorage.getItem(consts.STORAGE_BILLING)
    ? JSON.parse(sessionStorage.getItem(consts.STORAGE_BILLING))
    : {
        inputErrors: [],
        email: "",
        firstName: "",
        lastName: "",
        business: false,
        company: "",
        address: "",
        city: "",
        state: consts.DEFAULT_BILLING_STATE,
        zip: "",
        cardNumber: "",
        expiration: "",
        cardCode: "",
      },
  quoteDetails: {},
  shippingMethods: [],
  receipt: null,
  quoteid: null,
  campaignID: null,
  orderAdjustments: [],
};

function reducer(state, action) {
  switch (action.type) {
    case consts.ACTION_ADD_ALERT:
      return { ...state, alerts: [...state.alerts, action.payload] };
    case consts.ACTION_DISMISS_ALERT: {
      let updatedAlerts = state.alerts.slice();
      updatedAlerts.shift();
      return {
        ...state,
        alerts: updatedAlerts,
      };
    }
    case consts.ACTION_SET_BUSY:
      return { ...state, busy: action.payload };
    case consts.ACTION_INITIALIZE_PROFILE:
      return {
        ...state,
        profile: action.payload,
      };
    case consts.ACTION_SET_CART:
      localStorage.setItem(consts.STORAGE_CART, JSON.stringify(action.payload));
      return {
        ...state,
        cart: action.payload,
      };
    case consts.ACTION_SET_QUOTE_DETAILS:
      return {
        ...state,
        quoteDetails: action.payload,
      };
    case consts.ACTION_SET_SUPPORT_PERCENT:
      sessionStorage.setItem(
        consts.STORAGE_SUPPORT_PERCENTAGE,
        action.payload.supportPercent
      );
      sessionStorage.setItem(
        consts.STORAGE_SUPPORT_TOTAL,
        action.payload.supportTotal
      );
      return {
        ...state,
        supportPercent: action.payload.supportPercent,
        supportTotal: action.payload.supportTotal,
      };
    case consts.ACTION_SET_SUPPORT_TOTAL:
      sessionStorage.setItem(consts.STORAGE_SUPPORT_PERCENTAGE, null);
      sessionStorage.setItem(consts.STORAGE_SUPPORT_TOTAL, action.payload);
      return { ...state, supportPercent: null, supportTotal: action.payload };
    case consts.ACTION_SET_OPT_IN:
      sessionStorage.setItem(
        consts.STORAGE_OPT_IN,
        JSON.stringify(action.payload)
      );
      return {
        ...state,
        optIn: action.payload,
      };
    case consts.ACTION_SET_BUSINESS_USE:
      sessionStorage.setItem(
        consts.STORAGE_BUSINESS_USE,
        JSON.stringify(action.payload)
      );
      return {
        ...state,
        businessUse: action.payload,
      };
    case consts.ACTION_SET_BILLING:
      sessionStorage.setItem(
        consts.STORAGE_BILLING,
        JSON.stringify(action.payload)
      );
      return {
        ...state,
        billing: action.payload,
      };
    case consts.ACTION_INITIALIZE_SHIPPING_METHODS:
      return { ...state, shippingMethods: action.payload };
    case consts.ACTION_COMPLETE_PURCHASE:
      localStorage.removeItem(consts.STORAGE_CART);
      localStorage.removeItem(consts.STORAGE_QUOTE_ID);
      sessionStorage.removeItem(consts.STORAGE_COUPON_CODE);
      sessionStorage.removeItem(consts.STORAGE_BILLING);
      sessionStorage.removeItem(consts.STORAGE_OPT_IN);
      sessionStorage.removeItem(consts.STORAGE_BUSINESS_USE);
      sessionStorage.removeItem(consts.STORAGE_SUPPORT_PERCENTAGE);
      sessionStorage.removeItem(consts.STORAGE_SUPPORT_TOTAL);
      localStorage.setItem(
        consts.STORAGE_RECEIPT,
        JSON.stringify(action.payload)
      );
      return { ...state, receipt: action.payload };
    default:
      return state;
  }
}

export function Provider(props) {
  let cart = props.cart
    ? props.cart
    : localStorage.getItem(consts.STORAGE_CART)
      ? JSON.parse(localStorage.getItem(consts.STORAGE_CART))
      : [];
  localStorage.setItem(consts.STORAGE_CART, JSON.stringify(cart));

  // let quoteid = props.quoteid
  //   ? props.quoteid
  //   : localStorage.getItem(consts.STORAGE_QUOTE_ID)
  //   ? JSON.parse(localStorage.getItem(consts.STORAGE_QUOTE_ID))
  //   : null;
  // if (quoteid) {
  //   localStorage.setItem(consts.STORAGE_QUOTE_ID, JSON.stringify(quoteid));
  // }

  let quoteid = props.quoteid ? props.quoteid : null;

  let businessUse = props.quoteDetails
    ? props.quoteDetails.billingBusiness
    : false;

  let billing = props.quoteDetails
    ? {
        email: props.quoteDetails.billingEmail,
        firstName: props.quoteDetails.billingFirstName,
        lastName: props.quoteDetails.billingLastName,
        company: props.quoteDetails.billingCompany,
        address: props.quoteDetails.billingAddress,
        city: props.quoteDetails.billingCity,
        state: props.quoteDetails.billingState,
        zip: props.quoteDetails.billingZip,
        cardNumber: props.quoteDetails.billingCardNumber,
        expiration: props.quoteDetails.billingExpiration,
        cardCode: props.quoteDetails.billingCardCode,
      }
    : initialState.billing;

  let campaignID = props.quoteDetails ? props.quoteDetails.campaignID : null;
  let orderAdjustments =
    props.quoteDetails && props.quoteDetails.orderAdjustments
      ? JSON.parse(props.quoteDetails.orderAdjustments)
      : [];

  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
    cart: cart,
    quoteid: quoteid,
    quoteDetails: props.quoteDetails,
    billing: billing,
    businessUse: businessUse,
    campaignID: campaignID,
    orderAdjustments: orderAdjustments,
  });
  const value = { state, dispatch };
  return <State.Provider value={value}>{props.children}</State.Provider>;
}
